<template>
  <div class="site-template-preview template-preview">
    <div class="template-preview__image">
      <img
        v-if="(imgIsLoading || isLoading) && selectedMediaType === EMediaTypes.desktop"
        src="./images/skelet_desktop.png"
        fetchpriority="high"
      />
      <img
        v-else-if="(imgIsLoading || isLoading) && selectedMediaType === EMediaTypes.mobile"
        src="./images/skelet_mobile.png"
        fetchpriority="high"
      />
      <img
        v-if="!isLoading"
        :class="[
          {
            'template-preview__image img--disabled': imgIsLoading,
          },
        ]"
        :src="imgSrc"
        :alt="item.title"
        @load="imgIsLoad"
        @error="imgIsNotLoad"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Types } from '@/entities/site-template';
import { EMediaTypes } from '@/types';

const props = defineProps({
  item: {
    type: Object as PropType<Types.ISiteTemplate>,
    required: true,
  },

  isLoading: {
    type: Boolean as PropType<boolean>,
    default: false,
  },

  selectedMediaType: {
    type: String as PropType<EMediaTypes>,
    required: true,
  },
});

const imgIsLoading = ref(true);

const imgSrc = computed(() => {
  return new URL(
    `${props.selectedMediaType === EMediaTypes.desktop ? props.item.previewImageUrl : props.item.mobilePreviewImageUrl}`,
    import.meta.url,
  ).href;
});

watch(imgSrc, () => (imgIsLoading.value = true));

defineEmits(['select', 'close']);

const imgIsLoad = () => {
  imgIsLoading.value = false;
};

const imgIsNotLoad = () => {
  console.error('Ошибка загрузки изображения');
  imgIsLoading.value = false;
};
</script>

<style lang="scss" scoped>
.site-template-preview {
  width: 1280px;
  height: auto;
  background-color: white;
}

.template-preview {
  &__image {
    width: 100%;
    height: 100%;
    background-color: black;
    text-align: center;

    &.img {
      &--disabled {
        display: none;
      }
    }
  }
}
</style>
